import {toPost} from "../../http-utils";

export const messageStick = toPost<
    {
        id:number
    },
    { }
    >("/merchant/live/messageStick")